import { AB_CONFIG_KEYS } from "../../constants/AbConfigKeys";
import {AB_CONFIG_SET} from "../../constants/ActionTypes";

const initialState = {
  ...AB_CONFIG_KEYS,
};

// Critical config keys that should always have fallback values
const CRITICAL_CONFIG_FALLBACKS = {
  'mmt.desktop.rail.default.default.default.rails_fctg_dweb': true,
  'mmt.desktop.rail.default.default.default.rails_fc_tg_together_dweb': 2,
};

// Validate and apply fallbacks for critical config values
const validateCriticalConfigs = (data) => {
  if (!data) return {};
  
  const validatedData = { ...data };
  
  Object.keys(CRITICAL_CONFIG_FALLBACKS).forEach(key => {
    const value = validatedData[key];
    const fallbackValue = CRITICAL_CONFIG_FALLBACKS[key];
    
    // Apply fallback if value is null, undefined, false, or 0
    if (value === null || value === undefined || value === false || value === 0) {
      console.warn(`[AbConfig] Invalid value for ${key}: ${value}. Using fallback: ${fallbackValue}`);
      validatedData[key] = fallbackValue;
    }
  });
  
  return validatedData;
};

export default function(state = initialState, action) {
  if (action.type === AB_CONFIG_SET) {
    const validatedData = validateCriticalConfigs(action.payload.data);
    
    return {
      ...state,
      ...validatedData,
    }
  }
  return state;
}
